
function copyObject(a) {
  return JSON.parse(JSON.stringify(a));
}

export default copyObject;
